const EVENT_MOUSE_ENTER = Modernizr.mobile && Modernizr.touchevents ? 'touchstart' : 'mouseenter';
const EVENT_MOUSE_LEAVE = Modernizr.mobile && Modernizr.touchevents ? 'touchend' : 'mouseleave';

const $backgrounds = $('.js-hover-backgrounds');

if ($backgrounds.length) {
    $(document).on('touchstart', function onTouchStart(ev) {
        const $target = $(ev.target);
        const hasTalesListRoot = $target.closest('.js-hover-background-element').length > 0;

        if (!hasTalesListRoot) {
            $backgrounds.trigger('reset-background-state');
        }
    })
}

$(document).on('resize', function onResize() {
    $backgrounds.trigger('reset-background-state');
});

$backgrounds.each(function eachBackground(index, Root) {
    const $root = $(Root);
    const $items = $root.find('.js-hover-background-element');
    const $backgrounds = $('<div/><div/>');
    const $triggerHoverElement = $root.attr('data-head-theme') ? $root : $root.closest('.js-trigger-head-theme');
    const defaultTheme = $triggerHoverElement.attr('data-head-theme');
    const hasModal = $root.data('hover-backgrounds-has-modal');

    /**
     *
     * @property {number} elementIndex 0 или 1
     * @property {string|null} src
     * @type {object}
     */
    let currentBackground = {
        elementIndex: 0,
        src: null
    };

    let timeoutBeforeRemoveBackground;

    $backgrounds.addClass('js-hover-background');

    $root.append($backgrounds);

    // предзагрузка фонов
    $items.each(function eachItemPreloadBackground(index, Tale) {
        new Image().src = getBackgroundSrc(Tale);
    });

    $root
        .on('click', 'a', function onMouseEnter(ev) {
            if ('#' === ev.currentTarget.hash) {
                ev.preventDefault();
            }
        })
        .on(EVENT_MOUSE_ENTER, '.js-hover-background-element', function onMouseEnter(ev) {
            if (isBackgroundEnabled()) {
                clearTimeout(timeoutBeforeRemoveBackground);

                $root.addClass('hover');

                const $element = $(ev.currentTarget);
                const backgroundSrc = getBackgroundSrc($element);

                if (backgroundSrc !== currentBackground.src) {
                    currentBackground.src = backgroundSrc;

                    let nextBackgroundElementIndex = 0 === currentBackground.elementIndex ? 1 : 0;

                    const $nextBackground = $backgrounds.eq(nextBackgroundElementIndex);
                    const $prevBackground = $backgrounds.eq(currentBackground.elementIndex);

                    $nextBackground.css({backgroundImage: `url(${backgroundSrc})`});

                    $prevBackground.removeClass('active');
                    $nextBackground.addClass('active');

                    currentBackground.elementIndex = nextBackgroundElementIndex;

                    if (NLMK.isSolutionBoxOpen) {
                        setSectionTheme('light');
                    }

                    else {
                        NLMK.triggerHeadTheme();
                    }
                }

                NLMK.triggerHeadTheme('light');
            }

            else if (currentBackground.src) {
                resetState();
            }
        })
        .on('mouseleave', '.js-hover-background-container', function onMouseLeave() {
            if (hasModal && NLMK.isSolutionBoxOpen) {

            }

            else {
                resetState();
            }
        })
        .on(EVENT_MOUSE_ENTER, function () {
            $root.addClass('hover');
        })
        .on('mouseleave', function () {
            $root.removeClass('hover');
        })
        .on(EVENT_MOUSE_ENTER, '.js-hover-background-element', function () {
            $(this).addClass('hover');
        })
        .on(EVENT_MOUSE_LEAVE, '.js-hover-background-element', function () {
            $(this).removeClass('hover');
        })
        .on('reset-background-state', resetState)
    ;

    function resetState() {
        $root.removeClass('hover');
        $items.removeClass('hover');

        $backgrounds.removeClass('active');

        currentBackground = {
            elementIndex: 0,
            src: null
        };

        clearTimeout(timeoutBeforeRemoveBackground);

        setSectionTheme();

        NLMK.triggerHeadTheme();
    }

    /**
     *
     * @param {string} theme
     */
    function setSectionTheme(theme = defaultTheme) {
        $triggerHoverElement.attr('data-head-theme', theme);
    }
});

/**
 * @returns {boolean}
 */
function isBackgroundEnabled() {
    return innerWidth >= 0;
}

/**
 *
 * @param {jQuery|HTMLElement} $item
 * @returns {string}
 */
function getBackgroundSrc($item) {
    const rawSrc = $($item).data('hover-background-src');

    return encodeURI(decodeURI(rawSrc));
}




// WEBPACK FOOTER //
// ./js/main/plugin/hover-backgrounds.js